import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useQuote } from "@/lib/useQuote";
import { CartLines, CartTotals, DiscountCodeInput } from "@/components/store/CartLines";

export default function CartPage() {
  const { items, code } = useCart();
  const { quote, error } = useQuote(items, code);
  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24" data-testid="cart-page">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter uppercase text-white">Your Bag</h1>
      {items.length === 0 ? (
        <div className="mt-16 border border-white/10 py-24 text-center" data-testid="cart-page-empty">
          <p className="text-zinc-400">Your bag is empty.</p>
          <Link to="/shop" className="btn-store mt-8" data-testid="cart-page-shop-button">Shop the drop</Link>
        </div>
      ) : (
        <div className="mt-12 grid lg:grid-cols-[1.6fr_1fr] gap-12">
          <div className="border-t border-white/10"><CartLines quote={quote} /></div>
          <div className="border border-white/10 bg-[#0a0a0c] p-8 self-start space-y-6">
            <DiscountCodeInput quote={quote} />
            <CartTotals quote={quote} />
            {error && <p className="text-xs text-[#ff6b6b]" data-testid="cart-quote-error">{error}</p>}
            <Link to="/checkout" className="btn-store w-full" data-testid="cart-page-checkout-button">Checkout</Link>
            <Link to="/shop" className="block text-center text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-white">Continue shopping</Link>
          </div>
        </div>
      )}
    </div>
  );
}
